import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import { LoadingButton } from "@mui/lab";
import MultipleDatabaseSetup from "src/scenes/integrations/notion-setup/multiple-database-setup";

const steps = ["Setup your Tasks Database", "Setup your Sprints Database"];

const NotionSetupStepper = ({
    handleSaveSetup,
    userDatabases,
    selectedTasksDatabases,
    selectedSprintsDatabases,
    setSelectedSprintsDatabases,
    loading,
    setSelectedTasksDatabases,
    databasesFullPaths,
    setAllTaskFields,
    allTaskFields,
    allBugTypes,
    setAllBugTypes,
    allSprintFields,
    setAllSprintFields,
    loadingPathId,
}) => {
    const [activeStep, setActiveStep] = React.useState(0);
    const [hasError, setHasError] = React.useState(false);
    const [taskDatabasesCount, setTaskDatabasesCount] = React.useState(1);
    const [sprintDatabasesCount, setSprintDatabasesCount] = React.useState(0);

    React.useEffect(() => {
        setTaskDatabasesCount(selectedTasksDatabases && selectedTasksDatabases.length);
        setSprintDatabasesCount(selectedSprintsDatabases && selectedSprintsDatabases.length);
    }, [selectedTasksDatabases, selectedSprintsDatabases]);
    const handleNext = () => {
        if (!selectedTasksDatabases) {
            return;
        }
        const newActiveStep = activeStep + 1;
        setActiveStep(newActiveStep);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step) => () => {
        setActiveStep(step);
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Stepper activeStep={activeStep}>
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepButton color="inherit" onClick={handleStep(index)}>
                            {label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
            <div>
                {activeStep === 0 && (
                    <MultipleDatabaseSetup
                        userDatabases={userDatabases}
                        selectedDatabases={selectedTasksDatabases}
                        setSelectedDatabases={setSelectedTasksDatabases}
                        setHasError={setHasError}
                        title="Tasks"
                        taskDatabasesCount={taskDatabasesCount}
                        sprintDatabasesCount={sprintDatabasesCount}
                        databasesFullPaths={databasesFullPaths}
                        setAllTaskFields={setAllTaskFields}
                        allTaskFields={allTaskFields}
                        allBugTypes={allBugTypes}
                        setAllBugTypes={setAllBugTypes}
                        loadingPathId={loadingPathId}
                    />
                )}
                {activeStep === 1 && (
                    <MultipleDatabaseSetup
                        userDatabases={userDatabases}
                        selectedDatabases={selectedSprintsDatabases}
                        setSelectedDatabases={setSelectedSprintsDatabases}
                        setHasError={setHasError}
                        title="Sprints"
                        taskDatabasesCount={taskDatabasesCount}
                        sprintDatabasesCount={sprintDatabasesCount}
                        databasesFullPaths={databasesFullPaths}
                        allSprintFields={allSprintFields}
                        setAllSprintFields={setAllSprintFields}
                        loadingPathId={loadingPathId}
                    />
                )}
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Button
                        color="inherit"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1 }}
                    >
                        Back
                    </Button>
                    <Box sx={{ flex: "1 1 auto" }} />
                    {activeStep !== 1 && (
                        <Button onClick={handleNext} sx={{ mr: 1 }} disabled={hasError}>
                            Next
                        </Button>
                    )}
                    {activeStep === 1 && (
                        <LoadingButton
                            variant="contained"
                            size="medium"
                            disabled={hasError}
                            loading={loading}
                            onClick={() => {
                                handleSaveSetup();
                            }}
                        >
                            Save Setup
                        </LoadingButton>
                    )}
                </Box>
            </div>
        </Box>
    );
};

export default NotionSetupStepper;
